import { userToursSeenAtom } from '@/global-store.jsx';
import { useAtom } from 'jotai';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Joyride from 'react-joyride';
import { useLocation } from 'react-router-dom';

/**
 * UserTour component to guide users through a set of steps.
 * @param {Object} props - The props object.
 * @param {Object[]} props.steps - An array of steps for the tour.
 * @param {Object} [props.joyrideProps] - Optional. Props to pass to the Joyride component.
 */

// @param {boolean} [props.isIntroTour] - Optional. If true, the tour will be shown on all pages. THERE CAN ONLY BE ONE INTRO TOUR.
function UserTour({ /*isIntroTour, */ steps, joyrideProps }) {
    const { t } = useTranslation();

    const location = useLocation();

    const path = /*isIntroTour ? 'INTRO_TOUR' : */ location.pathname;

    const [userToursSeen, setUserToursSeen] = useAtom(userToursSeenAtom);

    const [runJoyride, setRunJoyride] = useState(false);

    useEffect(() => {
        if (userToursSeen?.includes(path)) return;

        // if this is not the intro tour and the intro tour has not been seen, don't run this tour
        //if (!isIntroTour && !userToursSeen?.includes('INTRO_TOUR')) return;

        setTimeout(() => {
            //document.body.style.overflow = 'hidden';
            setRunJoyride(true);
            window.scrollTo(0, 0);
            document.body.scrollTop = 0;
            document.documentElement.scrollTop = 0;
        }, 150);
    }, [userToursSeen?.length, path, userToursSeen]);

    return (
        <Joyride
            callback={data => {
                // check if the tour has been completed by either skipping or finishing it
                if (
                    (data.status === 'finished' || data.status === 'skipped') &&
                    data.lifecycle === 'complete'
                ) {
                    document.body.style.overflow = 'auto';
                    setRunJoyride(false);
                    setUserToursSeen(prev => [...prev, path]);
                }
            }}
            continuous
            disableOverlayClose
            disableScrolling
            hideCloseButton
            locale={{
                skip: (
                    <strong aria-label={t('dashboardGuideSkipButtonAria')}>
                        {t('dashboardGuideSkipButton')}
                    </strong>
                ),
                next: (
                    <span aria-label={t('dashboardGuideNextButtonAria')}>
                        {t('dashboardGuideNextButton')}
                    </span>
                ),
                back: (
                    <span aria-label={t('dashboardGuideBackButtonAria')}>
                        {t('dashboardGuideBackButton')}
                    </span>
                ),
                last: (
                    <span aria-label={t('dashboardGuideLastButtonAria')}>
                        {t('dashboardGuideLastButton')}
                    </span>
                ),
                close: (
                    <span aria-label={t('dashboardGuideCloseButtonAria')}>
                        {t('dashboardGuideCloseButton')}
                    </span>
                ),
                open: (
                    <span aria-label={t('dashboardGuideOpenButtonAria')}>
                        {t('dashboardGuideOpenButton')}
                    </span>
                )
            }}
            run={runJoyride}
            scrollOffset={30}
            showSkipButton
            steps={steps}
            styles={{
                options: {
                    zIndex: 9000,
                    primaryColor: '#000'
                }
            }}
            {...joyrideProps}
        />
    );
}

UserTour.propTypes = {
    isIntroTour: PropTypes.bool,
    joyrideProps: PropTypes.object,
    steps: PropTypes.array.isRequired
};

export default UserTour;
